import { AST } from '@handlebars/parser';
import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

type Config = Required<
  Pick<AST.BlockStatement, 'path' | 'hash' | 'params' | 'program' | 'inverse'>
> &
  Partial<AST.BlockStatement>;

export const createBlockStatement = (config: Config): AST.BlockStatement => ({
  type: NodeType.BlockStatement,
  openStrip: { close: false, open: false },
  inverseStrip: { close: false, open: false },
  closeStrip: { close: false, open: false },
  loc,
  ...config,
});
